module.exports = __webpack_public_path__ + "img/horizontal-glasshive-simplified.dc9a94eb.svg";